import React, { useEffect, useState } from 'react'
import {
  Container,
  Nav,
  Navbar,
  Col,
  Row,
  Button,
  Form,
  FormControl,
  InputGroup,
  Stack,
} from "react-bootstrap";
import Header from "../Header";
import Footer from "../Footer";
import { NavLink, Link } from "react-router-dom";
import Autocomplete from 'react-autocomplete'
import { Organization } from '../../Services/Organization';
import SchoolSignupStepOne from './SchoolSignupStepOne';
import SchoolSignupStepTwo from './SchoolSignupStepTwo';
import SchoolSignupStepThree from './SchoolSignupStepThree';
import SchoolSignupStepFour from './SchoolSignupStepFour';
import { buildUser } from '../../helpers/user-builder';

function SchoolRegistration(props) {
  const data = props.location.state ? props.location.state : null
  const [step, setstep] = useState(1);
  let userData = buildUser(data)
  // if (data) {
  //   userData = buildUser(data)
  // }
  const [schlFormData, setSchlFormData] = useState({
    ...userData,
    school: "",
    school_id: "",
    school_name: "",
    school_code: "",
    school_street: "",
    school_city: "",
    school_state: "",
    school_zip: "",
    logo: "",
    timezone:'',
    // logo_url:"",
    display_logo: "yes",
    // first_name: "",
    // last_name: "",
    // email: "",
    contact_number: "",
    contact_by: [],
    accept_privacy_policy: false


  })


  // function for going to next step by increasing step state by 1
  const nextStep = () => {
    setstep(step + 1);
  };

  // function for going to previous step by decreasing step state by 1
  const prevStep = () => {
    setstep(step - 1);
  };

  // handling form input data by taking onchange value and updating our previous form data state
  const handleInputData = input => e => {
    const { value } = e.target;

    //updating for data state taking previous state and then adding new value to create new object
    setSchlFormData(prevState => ({
      ...prevState,
      [input]: value
    }));
  }
  function handleImage(newValue) {
    setSchlFormData(prevState => ({
      ...prevState,
      ['logo']: newValue
    }));
  }

  function handleSchool(name, newValue) {
    setSchlFormData(prevState => ({
      ...prevState,
      [name]: newValue
    }));
  }
  const handleContactBy = input => e => {
    const { value, checked } = e.target;
    const { contact_by } = schlFormData;
    if (checked) {
      setSchlFormData(prevState => ({
        ...prevState,
        contact_by: [...contact_by, value],
      }));

    } else {
      setSchlFormData(prevState => ({
        ...prevState,
        contact_by: contact_by.filter((e) => e !== value),
      }));

    }
  }

  const [value, setValue] = useState('');
  const [error, setError] = useState();
  const [validated, setValidated] = useState(false);
  const [file, setFile] = useState();
  function handleChange(e) {
    setFile(URL.createObjectURL(e.target.files[0]));
  }



  switch (step) {
    case 1:
      return (
        <>
          <SchoolSignupStepOne nextStep={nextStep} handleImage={handleImage} handleFormData={handleInputData} handleSchool={handleSchool} values={schlFormData} />
        </>
      )
    case 2:
      return (
        <>
          <SchoolSignupStepTwo nextStep={nextStep} prevStep={prevStep} handleFormData={handleInputData} handleContactBy={handleContactBy} handleSchool={handleSchool} values={schlFormData} />
        </>
      )
    case 3:
      return (
        <>
          <SchoolSignupStepThree nextStep={nextStep} prevStep={prevStep} handleFormData={handleInputData} values={schlFormData} />
        </>
      )
    case 4:
      return (
        <>
          <SchoolSignupStepFour values={schlFormData} prevStep={prevStep} handleSchool={handleSchool} />
        </>
      )
    // never forget the default case, otherwise VS code would be mad!
    default:
    // do nothing
  }
}

export default SchoolRegistration
